/**
 * RealtimeNotificationManager
 * 
 * SSE bağlantısını yöneten ve bildirim gösteren component.
 * App.js içinde render edilir.
 */

import logger from '../utils/logger';
import { useRealtimeNotifications } from '../hooks/useRealtimeNotifications';

function RealtimeNotificationManager({
    enableSound = true,
    onNewOrder,
    onLowStock,
    onError
}) {
    // SSE bağlantısını başlat
    const { isConnected, connectionStatus, reconnect } = useRealtimeNotifications({
        enableSound,
        onNewOrder,
        onLowStock,
        onError
    });

    // Debug için connection status'u console'a yaz
    if (process.env.NODE_ENV === 'development') {
        logger.debug('Connection status', { connectionStatus, isConnected }, 'SSE');
    }

    // Bu component sadece hook'u çalıştırır, UI render etmez
    return null;
}

export default RealtimeNotificationManager;
